import { React, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

// eslint-disable-next-line import/prefer-default-export
export const AffiliatePaymentCommentsPopup = ({ modalStatus, handleClose, sendBtnHandler, isCommentPopup }) => {
  const [isSendBtnDisabled, setIsSendBtnDisabled] = useState(false);
  const [comments, setComments] = useState(null);
  const [error, setError] = useState(null);

  const handelTextareaChangeEvt = (e) => setComments(e.target.value);

  const handleSendBtnClick = async () => {
    if (isCommentPopup === true && comments === null) {
      setError('This field is required.');
    } else {
      setIsSendBtnDisabled(true);
      await sendBtnHandler(comments);
    }
  };

  useEffect(() => {
    setError(false);
    setIsSendBtnDisabled(false);
  }, [modalStatus]);

  return (
    <Modal
      className="filter-model dashbaord_popup"
      show={modalStatus}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <h5 className="modal-title w-100">Add Comments</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <textarea className='form-control' name="comments" placeholder='Put your comments here...' onChange={handelTextareaChangeEvt} defaultValue={comments} />
        </div>

        {error && (<div className='text-danger'>{error}</div>)}
      </Modal.Body>
      <Modal.Footer>

        <button
          type="button"
          className="btn btn-block themebtn1 w-100"
          onClick={handleSendBtnClick}
          disabled={isSendBtnDisabled}
        >
          {isCommentPopup === true ? 'Save Comments' : 'Pay Now'}
        </button>

      </Modal.Footer>
    </Modal>
  );
};
